import { styled } from '@linaria/react';
export var Header = /*#__PURE__*/styled("div")({
  name: "Header",
  class: "h6h3wkc"
});
export var Subheader = /*#__PURE__*/styled("div")({
  name: "Subheader",
  class: "sn741d4"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/age-gate/shared.linaria.module.css");